import WishlistButton from "./WishlistButton";

const getPosterUrl = (movie) => {
    // 1️⃣ Full URL stored incorrectly in poster_path
    if (movie.poster_path?.startsWith("http")) {
      return movie.poster_path;
    }
  
    // 2️⃣ TMDB relative poster path
    if (movie.poster_path) {
      return `https://image.tmdb.org/t/p/w500${movie.poster_path}`;
    }
  
    // 3️⃣ Firebase full URL poster
    if (movie.posterUrl?.startsWith("http")) {
      return movie.posterUrl;
    }
  
    // 4️⃣ Fallback
    return "/placeholder-poster.png";
  };
  

function MovieCard({
  movie,
  showRemove = false,
  onRemove,
}) {
  if (!movie) return null;

  return (
    <div className="movie-card">
      {/* ❤️ Wishlist */}
      <WishlistButton movie={movie} />

      {/* ❌ Remove (Wishlist only) */}
      {showRemove && typeof onRemove === "function" && (
        <button
          className="remove-overlay"
          onClick={(e) => {
            e.stopPropagation();
            onRemove(movie.id);
          }}
          aria-label="Remove from wishlist"
        >
          ✕
        </button>
      )}

      {/* 🎬 Poster */}
      <img
        src={getPosterUrl(movie)}
        alt={movie.title || movie.name}
        loading="lazy"
      />

      {/* Info */}
      <div className="movie-info">
        <h4>{movie.title || movie.name}</h4>

        {/* Cast (optional) */}
        {movie.cast?.length > 0 && (
          <p className="cast">
            {movie.cast.slice(0, 3).join(", ")}
          </p>
        )}

        {/* OTT Providers (text only for now) */}
        {/* {movie.ottProviders?.length > 0 && (
          <div className="ott-text-list">
            {movie.ottProviders.map((p) => (
              <span key={p.provider_name} className="ott-text">
                {p.provider_name}
              </span>
            ))}
          </div>
        )} */}
      </div>
    </div>
  );
}

export default MovieCard;
